import styled from 'styled-components';
import { spacing } from '@izettle/otto';
export const FieldContainer = styled.div `
  margin-bottom: ${(props) => (props.hasAppendedContent ? spacing.medium : spacing.small)};

  &:last-child {
    margin-bottom: 0;
  }
`;
